import { Box, Button, CircularProgress, Container, createTheme, CssBaseline, Dialog, DialogContent, DialogTitle, Grid, Paper, TextField, ThemeProvider, Typography } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { reportError } from "../../../../services/reportError";
import { getAllFromEduconCursosActivos } from "../../../../database/dbEduconCursosActivos";
import { getBankingInfo } from "../../../../database/dbBankingInfo";
import Swal from "sweetalert2";
import { getAllFromEduconCursosRegistrados } from "../../../../database/dbEduconCursosRegistrados";
import { CustomDialog } from "../../../modules/dialogs/CustomDialog";
import { Footer } from "../../../modules/ui/Footer";
import moment from "moment";
import { SelectCountryAndRegion } from "../../../modules/ui/SelectCountryAndRegion";
import { SelectCustom } from "../../../modules/ui/SelectCustom";
import { SelectCustomWithOther } from "../../../modules/ui/SelectCustomWithOther";
import { instituciones } from "../../../../helpers/catalogs/anuies";
import { generateRef } from "../../../../helpers/generateRef";
import { getEmpleados } from "../../../../database/dbEmpleados";
import validator from 'validator';
import { getAllEventosConRegistro } from "../../../../database/dbEventosConRegistro";
import { uploadFile } from "../../../../services/uploadFile";
import { postOne } from "../../../../database/dbRegistroGeneral";
import { renderToString } from "react-dom/server";
import { setEmailBodyRegistroGeneral } from "../../../../helpers/emails/setEmailBodyRegistroGeneral";
import QRCode from 'qrcode';
import { sendEmail } from "../../../../services/sendEmail";



export const Individual = () => {

    const { solicitudId } = useParams();

    // state para cuando esta cargando info
    const [isLoading, setIsLoading] = useState(true);
    // Para mostrar un dialogo mientras se envia la info (waiting dialog)
    const [sendingForm, setSendingForm] = useState(false);

    // state para la info bancaria (en caso de ser necesaria)
    const [bankingInfo, setBankingInfo] = useState(null);

    // state para las anuies
    const institucionesANUIES = instituciones.sort((a,b) => (a.nombre > b.nombre) ? 1 : ((b.nombre > a.nombre) ? -1 : 0));

    const [educon, setEducon] = useState(null);
    const [isMixed, setIsMixed] = useState(false);

    // state para los valores del formulario
    const [formValues, setFormValues] = useState({
        //* Los siguientes inputs los comparten todos los formularios (registros)
        partApellidoPaterno: "",
        partApellidoMaterno: "",
        partNombres: "",
        partCorreo: "",
        partCorreoConfirma: "",
        partPais: "",
        partEstado: "",
        tipoRegistro: "",
        tipoRegistroDocURL: "",

        registroClaveProyecto: "",
        registroFecha: moment().format('YYYY-MM-DDTHH:mm:ss'),
        registroReferencia: "",

        //* Estos son los elementos necesarios para este registro en particular
        partEdad: "",
        partSexo: "",
        partTelefono: "",
        partCelular: "",
        partLenguaIndigena: "",
        partDiscapacidad: "",
        partOcupacion: "",
        partGradoAcademico: "",
        partInstProcedencia: "",

        educonId: "",
        educonSolicitudId: "",
        educonInicio: "",
        educonTitulo: "",
        educonResponsableId: "",
        educonCorreo: "",
        educonModalidad: "",
    });
    const {
        partApellidoPaterno,
        partApellidoMaterno,
        partNombres,
        partCorreo,
        partCorreoConfirma,
        partPais,
        partEstado,
        tipoRegistro,

        registroClaveProyecto,
        registroFecha,
        registroReferencia,

        //*,
        partEdad,
        partSexo,
        partTelefono,
        partCelular,
        partLenguaIndigena,
        partDiscapacidad,
        partOcupacion,
        partGradoAcademico,
        partInstProcedencia,

        educonId,
        educonSolicitudId,
        educonInicio,
        educonTitulo,
        educonResponsableId,
        educonCorreo,
        educonModalidad,
    } = formValues;

    // state para el selector de tipoRegistro
    const [addCredential, setAddCredential] = useState(false);

    // state para el fileupload
    const [file, setFile] = useState({ file: '' });

    // state para el codigo QR
    const [src, setSrc] = useState({ qrdata:"" });


    // Check whether any of the form fields are unedited
    const isSendButtonDisabled = () => (
        false
        ||
        formValues.partApellidoPaterno.length === 0 ||
        formValues.partNombres.length === 0 ||
        formValues.partCorreo.length === 0 ||
        formValues.partCorreoConfirma.length === 0 ||
        formValues.partPais.length === 0 ||
        formValues.partEstado.length === 0 ||
        formValues.tipoRegistro.length === 0 ||
        // Lo nuevo
        formValues.partEdad.length === 0 ||
        formValues.partSexo.length === 0 ||
        formValues.partTelefono.length === 0 ||
        formValues.partCelular.length === 0 ||
        formValues.partLenguaIndigena.length === 0 ||
        formValues.partDiscapacidad.length === 0 ||
        formValues.partOcupacion.length === 0 ||
        formValues.partGradoAcademico.length === 0 ||
        formValues.partInstProcedencia.length === 0 ||

        formValues.educonTitulo.length === 0
    );

    // Cada que cambia el valor en cualquier control de formulario
    const handleInputChange = ({ target }) => {
        setFormValues({ ...formValues, [target.name]: target.value });
    };

    // Cada que cambia el pais y estado
    const handleCountryAndRegionChange = ({ country, region }) => {
        setFormValues({ ...formValues, partPais: country || '', partEstado: region || '' })
    }

    // Al seleccionar el tipo de registro
    const handleTipoRegistro = ({ target }) => {
        const { name, value } = target;
        switch (value) {
            case 'Participante externo':
                setAddCredential(false);
                break;
            default:
                setAddCredential(true);
                break;
        }
        setFormValues({ ...formValues, [name]: value });
    }



    const handleSubmit = async (event) => {
        event.preventDefault();

        console.log(formValues);
        console.log(file);
        //* Validar datos
        if ( !isFormValid() ) { return false; }

        //* Mostrar confirm dialog/waiting dialog
        Swal.fire({
            title: '¿Desea continuar?',
            text: "Por favor, confirme la información ingresada.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Regresar',
        }).then((result) => {
            if (result.isConfirmed) {
                //* El usuario confirma procesar la data
                continueConfirmed();
            }
        })
    }

    //* Validar el formumario
    const isFormValid = () => {

        // Campos de correo validos
        if ( !validator.isEmail(partCorreo) || !validator.isEmail(partCorreoConfirma) ) {
            Swal.fire("Correo electrónico incorrecto.", "Confirmar el correo electrónico ingresado.", "error");
            return false;
        }

        // Campos de correo  iguales
        if ( partCorreo !== partCorreoConfirma ) {
            Swal.fire("Confirmar correo electrónico.", "La confirmación de correo electrónico no coincide.", "error");
            return false;
        }

        if (addCredential) {
            // No ha indicado ningun archivo
            if ( file.file === '' ) {
                Swal.fire("Agregar documento.", `Por favor selecciona un archivo como credencial.`, "error");
                return false;
            }
            // Indico archivo pero no es un PDF
            const fullName = file.file.name;
            const fileExt = fullName.substring( fullName.indexOf('.') + 1 ).toUpperCase();
            if ( file.file !== '' && fileExt !== 'PDF' ) {
                Swal.fire("Documento incorrecto.", `La credencial debe ser un archivo PDF.`, "error");
                return false;
            }
        }

        if (isMixed) {
            if ( [ educonModalidad ].includes("") ) {
                Swal.fire("Datos incompletos.", "Es necesario seleccionar una modalidad.", "error");
                return false;
            }
        }

        return true;
    }

    //* Del sweetalert, cuando el usuario decide "continuar"
    const continueConfirmed = async() => {
        // Mostrar waiting dialog
        setSendingForm(true);

        // Se procesa la info
        const resultDataProcessed = await isDataProcessed(); 
        console.log({resultDataProcessed});

        // Ocultar waiting dialog
        setSendingForm(false);

        //* Error, notificar y avisar al desarrollador
        if (!resultDataProcessed) {
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                title: "Sucedío un error en el servidor.",
                text: 'Disculpe el inconveniente, por favor reintente más tarde.',
                icon: 'error',
                showConfirmButton: false,
                footer: 'El area correspondiente ya ha sido notificada.'
            }); 

            sendEmail({
                "toemail": "jcollins@cibnor.mx",
                "subject": "[Educon] Error",
                "message": formValues,
            });

            return;
        }

        //* Exito, notificar
        Swal.fire({
            allowEscapeKey: false,
            allowOutsideClick: false,
            confirmButtonText: 'Ver más cursos de educación continua',
            icon: 'success',
            text: 'Consulte su correo electrónico para más información.',
            title: "Sus datos han sido recibidos exitosamente",
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.replace('https://www.cibnor.gob.mx/posgrados/educacion-continua');
            }
        }); 
    }

    // Procesamiento de la info
    const isDataProcessed = async() => {

        // Si se requirió, se sube archivo
        if (addCredential) {
            // - subir archivo en PDF
            const resultUpload = await uploadFile({ file, fileName: `credTR_${ registroReferencia }.pdf` });
            console.log({resultUpload});

            // Error al subir el archivo, notificar y salir
            if (resultUpload.exito === 0) {
                reportError({ emailTo: 'jcollins@cibnor.mx', values: resultUpload, task: 'Al subir comprobante -tipoRegistro-' });
                return false;
            }

            formValues.tipoRegistroDocURL = `https://eventos.cibnor.mx/registro/apiServiciosSIARF${ resultUpload.data }`;
        }
        
        // Creamos el objeto
        const infoAdicionalObj = {
            partEdad,
            partSexo,
            partTelefono,
            partCelular,
            partLenguaIndigena,
            partDiscapacidad,
            partOcupacion,
            partGradoAcademico,
            partInstProcedencia,

            educonId,
            educonSolicitudId,
            educonInicio,
            educonTitulo,
            educonResponsableId,
            educonCorreo,
            educonModalidad,

            //? Eliminamos el guardar el qrdata (ocupa mucho espacio y es dificil de leer), sí se genera y se usa para el envio de coreo
            // registroDataQR: src.qrdata,
            
            //? En su lugar, guardamos la data que debe contener el codigo QR (de esta manera se puede generar en cualquier lado)
            registroQR: `https://eventos.cibnor.mx/registro/en-linea/visualizar-registro/${ registroReferencia }`,

            // 0 = no paga, 1 = paga y confirma su registro subiendo su comprobante
            registroConfirma: formValues.registroConfirma ?? 0, 
            registroConfirmaFecha: "",
        };


        //* Construir el objeto a enviar en el POST
        const valuesObj = {
            partApellidoPaterno: partApellidoPaterno,
            partApellidoMaterno: partApellidoMaterno,
            partNombres: partNombres,
            partCorreo: partCorreo,
            partPais: partPais,
            partEstado: partEstado,
            tipoRegistro: tipoRegistro,
            tipoRegistroDocURL: formValues.tipoRegistroDocURL,
            registroClaveProyecto: registroClaveProyecto,
            registroFecha: registroFecha,
            registroReferencia: registroReferencia,
            infoAdicional: JSON.stringify(infoAdicionalObj)
        }
        console.log("--- Objeto a enviar en el POST");
        console.log({valuesObj});

        //* POST en dbRegistroGeneral
        const resultPost = await postOne({ values:valuesObj });
        console.log({ resultPost });

        //* Error al guardar en la bdd, notificar y salir
        if (resultPost.exito === 0) {
            reportError({ emailTo: 'jcollins@cibnor.mx', values: resultPost, task: 'Al guardar en -RegistroGeneral-' });
            return false;
        }

        //* Construir 'eventData' para el envio de correo
        const eventData = { 
            correoEvento: educonCorreo,
            urlLogo: 'https://eventos.cibnor.mx/intranet/img/logo_cib.png', 
            tituloEvento: educonTitulo, 
            urlConfirmarRegistro: `https://eventos.cibnor.mx/registro/en-linea/confirmar-registro/${ registroReferencia }`
        }

        console.log("--- Objeto a enviar para crear el body del correo");
        console.log({eventData});
        
        // Armar el body con los datos del formulario y los datos del evento al que se esta registrando
        const msgbody = renderToString( setEmailBodyRegistroGeneral({ values: valuesObj, eventData, qrData: src.qrdata, bankingInfo }) );

        //* Si estas en produccion, agregale el correo del titular del evento
        const envToCC = process.env.REACT_APP_TOCC_EDUCON;
        const toccAddresses = (envToCC !== '') ? envToCC + `, ${ eventData.correoEvento }` : envToCC;
        console.log({toccAddresses});

        const emailResult = await sendEmail({
            "toemail": partCorreo,
            "subject": `Registro en línea [${ eventData.tituloEvento }]`,
            "message": msgbody,
            "replyto": eventData.correoEvento,
            "tocc": toccAddresses,
        });

        // Error al recuperar los generales del evento desde EventosConRegistro
        if (emailResult.exito === 0) {
            console.log({ emailResult });
            reportError({ emailTo: 'jcollins@cibnor.mx', values: emailResult, task: 'Al enviar el correo de acuse de registro' });
            return false;
        }

        return true;
    };



    //* Setea los valores iniciales
    useEffect(() => {
        
        const setInitialValues = async() => {
            document.title = "[EduCon] CIBNOR - Individual";

            const { exito, mensaje, data } = await getAllFromEduconCursosRegistrados();
            // console.log( exito, mensaje, data );

            const educonCursoRegistrado = data.find(d => d.solicitudID.toString() === solicitudId);
            console.log({educonCursoRegistrado});
            setEducon(educonCursoRegistrado);

            // Error al cargar el educon, notificar y salir
            if (exito === 0) {
                setIsLoading(false);
                reportError({ emailTo: 'jcollins@cibnor.mx', values: mensaje, task: 'En Individual, al cargar el curso EDUCON' });
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    html: `El incidente ya ha sido reportado. Dudas: <strong>educon@cibnor.mx</strong>`,
                    icon: 'error',
                    showConfirmButton: false,
                    title: `¡Ups! ocurrió un error. Por favor inténtelo mas tarde.`,
                });
                return
            }

            const result = await getBankingInfo();
            // console.log({result});
            if (result) {
                setBankingInfo(result.datos);
            }

            // Ya termino de cargar la info
            setIsLoading(false);

            // Destructuramos los datos del educon
            const { email, fechaInicio, folio, nombre, solicitudID, correoEventos, modalidad, cve_Proyec, cupo, costo } = educonCursoRegistrado;

            // Obtenemos el id del responsable a partir del correo del titular del educon 'email'
            const result_getEmpleados = await getEmpleados();
            const empleadoTitular = result_getEmpleados.data.find(emp => emp.emailNormal === email);

            // Generamos la referencia (dependiendo del valor de 'cve_Proyec')
            const registroRef =generateRef({ prefix:cve_Proyec !== '0' ? cve_Proyec : '24274' });

            // Establecemos el state principal de acuerdo a los datos recuperados
            setFormValues({
                ...formValues,
                educonId: folio,
                educonSolicitudId: solicitudID,
                educonInicio: fechaInicio,
                educonTitulo: nombre,
                educonResponsableId: empleadoTitular.num_emplea || 0,
                educonCorreo: correoEventos || 'educon@cibnor.mx',
                educonModalidad: modalidad,
                registroClaveProyecto: cve_Proyec,
                registroReferencia: registroRef,
                registroConfirma: costo > 0 ? 1 : 0,
            });
            
            // Seteamos el state de modalidad para mostrar/ocultar el control
            (modalidad.toLowerCase() === 'mixto') ? setIsMixed(true) : setIsMixed(false);

            // Generamos el qr y su string a almacenar
            const qrString = `${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${ registroRef }`;
            QRCode.toDataURL( qrString ).then( (data) => { 
                setSrc( { qrdata:data } );
            })
        }

        setInitialValues();
    }, [ ])



    return (
        <ThemeProvider theme={createTheme()}>

            {/* Dialogos de espera */}
            <CustomDialog show={ isLoading } title='Un momento por favor...'/>

            <CustomDialog show={ sendingForm } title='Enviando información...'/>

            { educon && (

                <Container component="main" maxWidth="sm" >
                    <CssBaseline />
                    <Box sx={{ mt: 4, mb: 8, display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Box my={ 6 }>
                            <Typography align="center" variant="h6">{ educon.nombre }</Typography>
                            <Typography align="center">Registro individual</Typography>
                        </Box>
                        
                        {/* Inicio del formulario */}
                        <Box
                            component="form"
                            noValidate
                            // onSubmit={handleSubmit}
                            autoComplete="off"
                            maxWidth="sm"
                        >
                            {/* Participante */}
                            <Paper elevation={2}>
                                <Grid container spacing={2} sx={{ flexGrow: 1, px: 3 }} paddingBottom={ 3 } >

                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            id="partApellidoPaterno"
                                            label={`Apellido paterno`}
                                            name="partApellidoPaterno"
                                            required
                                            size="small"
                                            value={partApellidoPaterno}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            id="partApellidoMaterno"
                                            label={`Apellido materno`}
                                            name="partApellidoMaterno"
                                            size="small"
                                            value={partApellidoMaterno}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="partNombres"
                                            label={`Nombre(s)`}
                                            name="partNombres"
                                            required
                                            size="small"
                                            value={partNombres}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="partCorreo"
                                            label="Correo electrónico"
                                            name="partCorreo"
                                            required
                                            size="small"
                                            value={partCorreo}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="partCorreoConfirma"
                                            label="Confirmar correo electrónico"
                                            name="partCorreoConfirma"
                                            required
                                            size="small"
                                            value={partCorreoConfirma}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    {/* Pais y estado */}
                                    <Grid item xs={12}>
                                        <SelectCountryAndRegion 
                                            parentCallback={handleCountryAndRegionChange} 
                                            paddingH={0}
                                            paddingV={0}
                                            variant="outlined" 
                                        />
                                    </Grid>
                                    {/* Tipo de registro [ trab, est, ext ] */}
                                    <Grid item xs={12} >
                                        <SelectCustom
                                            parentCallback={handleTipoRegistro}
                                            name={"tipoRegistro"}
                                            label={"Tipo de registro"}
                                            options={[
                                                {value:'Trabajador CIBNOR', label:'Trabajador CIBNOR'},
                                                {value:'Estudiante CIBNOR', label:'Estudiante CIBNOR'},
                                                {value:'Estudiante externo', label:'Estudiante externo'},
                                                {value:'Participante externo', label:'Participante externo'},
                                            ]}
                                            required
                                            variant="outlined" 
                                        />
                                    </Grid>
                                    {/* Documento probatorio, dependiendo lo seleccionado en tipoRegistro */}
                                    <Grid item xs={12} sx={{ display:(addCredential ? 'flex' : 'none')  }}>
                                        <TextField
                                            type={"file"}
                                            fullWidth
                                            onChange={ e => setFile({ file: e.target.files[0] }) }
                                            // onChange={e => setFileState(e)}
                                            helperText="Subir documento probatorio (credencial en archivo PDF) *"
                                            variant='standard'
                                        />
                                    </Grid>

                                    { /* Edad //* Nuevo */ }
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            id="partEdad"
                                            label="Edad"
                                            name="partEdad"
                                            required
                                            size="small"
                                            type='number'
                                            // value={partEdad}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    { /* Sexo //* Nuevo */ }
                                    <Grid item xs={6} >
                                        <SelectCustom
                                            parentCallback={handleInputChange}
                                            name={"partSexo"}
                                            label={"Sexo"}
                                            options={[
                                                { value:'Hombre', label:'Hombre' },
                                                { value:'Mujer', label:'Mujer' },
                                            ]}
                                            required
                                        />
                                    </Grid>
                                    { /* Telefono //* Nuevo */ }
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            id="partTelefono"
                                            label="Teléfono"
                                            name="partTelefono"
                                            required
                                            size="small"
                                            type='number'
                                            // value={partTelefono}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    { /* Celular //* Nuevo */ }
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            id="partCelular"
                                            label="Celular"
                                            name="partCelular"
                                            required
                                            size="small"
                                            type='number'
                                            // value={partCelular}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    { /* LenguaInd //* Nuevo */ }
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            id="partLenguaIndigena"
                                            label="Lengua indígena"
                                            name="partLenguaIndigena"
                                            required
                                            size="small"
                                            // value={partLenguaIndigena}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    { /* Discapacidad //* Nuevo */ }
                                    <Grid item xs={6} >
                                        <SelectCustom
                                            parentCallback={handleInputChange}
                                            name={"partDiscapacidad"}
                                            label={"Discapacidad"}
                                            options={[
                                                { value:'Física/motriz', label:'Física/motriz' },
                                                { value:'Intelectual', label:'Intelectual' },
                                                { value:'Múltiple', label:'Múltiple' },
                                                { value:'Hipoacusia', label:'Hipoacusia' },
                                                { value:'Sordera', label:'Sordera' },
                                                { value:'Visual', label:'Visual' },
                                                { value:'Baja visión', label:'Baja visión' },
                                                { value:'Ceguera', label:'Ceguera' },
                                                { value:'Psicosocial', label:'Psicosocial' },
                                                { value:'Ninguna', label:'Ninguna' },
                                            ]}
                                            required
                                        />
                                    </Grid>
                                    { /* Ocupacion //* Nuevo */ }
                                    <Grid item xs={12} >
                                        <SelectCustomWithOther parentCallback={handleInputChange}
                                            name={"partOcupacion"}
                                            label={"Ocupación"}
                                            options={[
                                                { value:'Estudiante', label:'Estudiante' },
                                                { value:'Técnico', label:'Técnico' },
                                                { value:'Investigador', label:'Investigador' },
                                            ]}
                                            variant='outlined'
                                        />
                                    </Grid>
                                    {/* Nivel de estudios  //* Nuevo */}
                                    <Grid item xs={6} >
                                        <SelectCustom
                                            parentCallback={handleInputChange}
                                            name={"partGradoAcademico"}
                                            label={ "Nivel de estudios" }
                                            options={[
                                                { value:'Bachillerato', label:'Bachillerato' },
                                                { value:'Carrera técnica', label:'Carrera técnica' },
                                                { value:'Licenciatura', label:'Licenciatura' },
                                                { value:'Maestría', label:'Maestría' },
                                                { value:'Doctorado', label:'Doctorado' },
                                                { value:'Postdoctorado', label:'Postdoctorado' },
                                                { value:'Maestría profesionalizante', label:'Maestría profesionalizante' },
                                                { value:'Especialización', label:'Especialización' },
                                                { value:'Diplomado', label:'Diplomado' },
                                                { value:'Curso de superación', label:'Curso de superación' },
                                            ]}
                                            required
                                        />
                                    </Grid>
                                    {/* Institucion de procedencia  //* Nuevo */}
                                    <Grid item xs={12}>
                                        <SelectCustomWithOther parentCallback={handleInputChange}
                                            name={"partInstProcedencia"}
                                            label={"Institución de procedencia *"}
                                            options={ 
                                                institucionesANUIES.map( inst => (
                                                    { value: `${inst.nombre} (${inst.clave})`, label:`${inst.nombre} (${inst.clave})` }
                                                    ))
                                            }
                                            inputWidth={12}
                                            paddingH={0}
                                            paddingV={0}
                                            variant='outlined' 
                                        />
                                    </Grid>

                                    {/* //* Modalidad, en caso de ser mixto */}
                                    <Grid item xs={ 12 } sx={{ display:(isMixed ? 'flex' : 'none') }}>
                                        <SelectCustom
                                            parentCallback={ ({ target }) => setFormValues({ ...formValues, educonModalidad: target.value }) }
                                            name='educonModalidad'
                                            label='Seleccione la modalidad'
                                            options={[
                                                { value: 'Presencial', label: 'Presencial' },
                                                { value: 'Virtual', label: 'Virtual' },
                                            ]}
                                            required
                                        />
                                    </Grid>

                                </Grid>
                            </Paper>


                            {/* Boton */}
                            <Grid container spacing={2} sx={{ pt: 3 }}>
                            <Grid item xs={12}>
                                <Paper elevation={2} >
                                    <Button
                                        type='submit'
                                        fullWidth
                                        endIcon={<SendIcon />}
                                        onClick={ handleSubmit }
                                        disabled={ isSendButtonDisabled() }
                                    >
                                        Enviar
                                    </Button>
                                </Paper>
                            </Grid>
                            </Grid>

                        </Box>

                        {/* Footer */}
                        <Footer />
                    </Box>
                </Container>

            ) }
        </ThemeProvider>
    )
}
